import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import IframeIcon from '../../images/iframe-icon.png';

const CopyIframeButton = ({ text, onCopy, size, marginLeft }) => (
  <Tooltip title="Copy iframe script" placement="top" arrow>
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft,
        height: size,
        verticalAlign: 'middle',
      }}
    >
      <CopyToClipboard text={text} onCopy={onCopy}>
        <img
          src={IframeIcon}
          alt="Copy iframe script"
          style={{
            display: 'block',
            width: size,
            height: size,
            cursor: 'pointer',
          }}
        />
      </CopyToClipboard>
    </span>
  </Tooltip>
);

CopyIframeButton.propTypes = {
  text: PropTypes.string.isRequired,
  onCopy: PropTypes.func.isRequired,
  size: PropTypes.number,
  marginLeft: PropTypes.number,
};

CopyIframeButton.defaultProps = {
  size: 24,
  marginLeft: 5,
};

export default CopyIframeButton;
